import axiosInstance from '../axiosInstance';

/**
 * MVP 목록 조회
 */
export const getMyMVPs = async () => {
  try {
    const response = await axiosInstance.get(`/mvp/my`);
    return response.data.data;
  } catch (error) {
    console.error('Get My MVPs API Error:', error);
    throw error;
  }
};

export const getWorkshopMVPs = async (workshopId) => {
  try {
    const response = await axiosInstance.get(`/mvp/workshops/${workshopId}`);
    return response.data.data;
  } catch (error) {
    console.error('Get Workshop MVPs API Error:', error);
    throw error;
  }
};

/**
 * MVP 지정
 * @param {number} bookingId
 */
export const assignMvp = async (bookingId) => {
  try {
    await axiosInstance.post(`/mvp/${bookingId}`);
  } catch (error) {
    console.error('Assign MVP API Error:', error);
    throw error;
  }
};

/**
 * MVP 해제
 * @param {number} bookingId
 */
export const removeMvp = async (bookingId) => {
  try {
    await axiosInstance.delete(`/mvp/${bookingId}`);
  } catch (error) {
    console.error('Remove MVP API Error:', error);
    throw error;
  }
};
